import React from "react";

const VideoSection = ({ className, setIsVideoStarted, setVideoModalOpen }) => {
  // Generate a unique ID for the gradient
  const gradientId = `gradient-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={className} data-aos="fade-up" data-aos-delay="1000">
      <div
        className="relative flex justify-center items-center"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <img
          className="mx-auto rounded-lg"
          src={require("../images/outdated-incentives.png").default}
          width="524"
          height="104"
          alt="Hero"
        />
        <a
          className="absolute group cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsVideoStarted(true);
            setVideoModalOpen(true);
          }}
          aria-controls="modal"
        >
          <svg
            className="w-16 h-16 sm:w-20 sm:h-20 hover:opacity-75 transition duration-150 ease-in-out animate-gen-pulse-zero"
            viewBox="0 0 88 88"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                x1="78.169%"
                y1="9.507%"
                x2="24.434%"
                y2="90.469%"
                id={gradientId}
              >
                <stop stopColor="#525BE8" stopOpacity=".8" offset="0%" />
                <stop stopColor="#525BE8" offset="100%" />
              </linearGradient>
            </defs>
            <circle fill={`url(#${gradientId})`} cx="44" cy="44" r="44" />
            <path
              className="fill-current text-white"
              d="M58 44a2 2 0 00-.854-1.64L37.146 28.36A2 2 0 0034 30v28a2 2 0 003.146 1.64l20-14A2 2 0 0058 44z"
            />
          </svg>
        </a>
      </div>
      <div
        className="text-center text-primary-1 font-bold font-barlow md:text-2xl text-xl mt-6"
        data-aos="fade-up"
        data-aos-delay="1200"
      >
        Watch and learn more...
      </div>
    </div>
  );
};

export default VideoSection;
